import { getEnvironment, getRegionFromHost } from '../../index';
const authConfig = {
    DEU: {
        local: 'https://auth-deu-development.raisin-dev.network/',
        development: 'https://auth-deu-development.raisin-dev.network/',
        staging: 'https://auth.staging-weltsparen.de/',
        onboarding: 'https://auth.onboarding-weltsparen.de/',
        production: 'https://auth.weltsparen.de/',
        namespace: (name) => `https://auth-deu-${name}.raisin-dev.network/`,
    },
    GBR: {
        local: 'https://auth-gbr-development.raisin-dev.network/',
        development: 'https://auth-gbr-development.raisin-dev.network/',
        staging: 'https://auth.staging-raisin.co.uk/',
        onboarding: 'https://auth.onboarding-raisin.co.uk/',
        production: 'https://auth.raisin.co.uk/',
        namespace: (name) => `https://auth-gbr-${name}.raisin-dev.network/`,
    },
};
export const getAuthBaseUrl = () => {
    const environment = getEnvironment();
    const region = getRegionFromHost();
    return authConfig[region][environment] || authConfig[region].namespace(environment);
};
//# sourceMappingURL=microservicesConfig.js.map